import { useEffect, useRef } from "react";
import { ExternalLink } from "lucide-react";
import {
  TRUSTBOX_TEMPLATES,
  TRUSTPILOT_BUSINESS_UNIT_ID,
  TRUSTPILOT_PROFILE_URL,
  isTrustpilotLive,
} from "@/lib/trustpilot";

const WIDGET_SCRIPT =
  "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

/**
 * Tiny live Trustpilot review carousel (official TrustBox — real reviews only).
 * Renders nothing but a quiet link-out until a Business Unit ID is configured.
 */
export function TrustpilotMiniCarousel() {
  const ref = useRef<HTMLDivElement>(null);
  const live = isTrustpilotLive();

  useEffect(() => {
    if (!live || !ref.current) return;

    const mount = () => {
      if (window.Trustpilot && ref.current) {
        window.Trustpilot.loadFromElement(ref.current, true);
      }
    };

    let script = document.querySelector<HTMLScriptElement>(
      `script[src="${WIDGET_SCRIPT}"]`,
    );
    if (!script) {
      script = document.createElement("script");
      script.src = WIDGET_SCRIPT;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", mount);
    mount();
    return () => script?.removeEventListener("load", mount);
  }, [live]);

if (!live) {
    return null;
  }

  return (
    <div className="mx-auto mt-3 w-full max-w-3xl lg:max-w-[1100px]">
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id={TRUSTBOX_TEMPLATES.carousel}
        data-businessunit-id={TRUSTPILOT_BUSINESS_UNIT_ID}
        data-style-height="130px"
        data-style-width="100%"
        data-theme="light"
        data-stars="4,5"
        data-review-languages="en"
      >
        <a href={TRUSTPILOT_PROFILE_URL} target="_blank" rel="noopener noreferrer">
          Trustpilot
        </a>
      </div>
    </div>
  );
}
